var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s-vstack"},[_c('Status'),_c('v-row',{attrs:{"align":"center","justify":"center","wrap":""}},[_c('v-col',{attrs:{"cols":"10","sm":"4"}},[_c('Member')],1),_c('v-col',{attrs:{"cols":"10","sm":"4"}},[_c('Sales')],1),_c('v-col',{attrs:{"cols":"10","sm":"4"}},[_c('Redeem')],1)],1),_c('Upgrade'),_c('Tier'),_c('URL')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }